var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisplaySmallCustomClock = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.959 3C8.365 3 3 8.365 3 14.959c0 6.594 5.365 11.959 11.959 11.959 6.594 0 11.958-5.365 11.958-11.96C26.917 8.366 21.553 3 14.96 3zm0 22.203c-5.649 0-10.245-4.595-10.245-10.244 0-5.65 4.596-10.245 10.245-10.245 5.649 0 10.244 4.596 10.244 10.245 0 5.649-4.595 10.244-10.244 10.244z",
    fill: "#1E2969"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.108 14.758h-5.62V8.615a.857.857 0 1 0-1.714 0v7c0 .474.384.858.857.858h6.477a.857.857 0 1 0 0-1.715z",
    fill: "#1B7690"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisplaySmallCustomClock);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/display-small-custom-clock.1b5e510ec01d73438d7e3d7a7b586ce5.svg";